import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 18"
      className="design-iconfont"
    >
      <path d="M8.572 8.041C11.98 8.041 15.055 9.56 17 12c-.894-3.596-4.334-6.283-8.428-6.283a.943.943 0 0 1-.957-.93V3L3 6.88l4.615 3.915V8.971c0-.514.428-.93.957-.93M17.788 17a.946.946 0 0 1-.92-.718c-.844-3.434-3.81-5.915-7.385-6.29v1.054c0 .665-.397 1.257-1.036 1.544-.692.313-1.5.2-2.062-.286l-4.8-4.164A1.672 1.672 0 0 1 1 6.883c0-.476.213-.934.585-1.258l4.8-4.163c.562-.487 1.37-.6 2.062-.287.639.288 1.036.88 1.036 1.544v1.146C14.81 4.33 19 8.671 19 13.941c0 .763-.099 1.55-.292 2.34a.943.943 0 0 1-.92.719" />
    </svg>
  )
}
const ExporterIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
ExporterIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
ExporterIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default ExporterIcon
